import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM17.7216 8.27722C17.3504 7.90759 16.7486 7.90759 16.3774 8.27722L10.5149 14.115L7.6226 11.235C7.25141 10.8653 6.64958 10.8653 6.27839 11.235C5.9072 11.6046 5.9072 12.2039 6.27839 12.5735L9.84275 16.1228C10.2139 16.4924 10.8158 16.4924 11.187 16.1228L17.7216 9.61574C18.0928 9.24612 18.0928 8.64684 17.7216 8.27722Z"
      fill={fill}
      fillRule="evenodd"
    />
  </g>
);

export default Icon;
